<template>
    <el-dialog
            title=""
            :visible.sync="releaseDialogVisible"
            :close-on-click-modal="false"
            @close='cancelDialog()'
            :before-close="handleDialogClose"
            custom-class="release-dialog"
            top="3vh"
            width="684px">
        <div class="dialog-cont">
            <h3 class="title">发布动态</h3>
            <p class="tips">分享出您此刻的感受吧～</p>
            <el-input
                    type="textarea"
                    :autosize="{ minRows: 12, maxRows: 20 }"
                    resize="none"
                    v-model="content"
                    class="inp-textArea"
            >
            </el-input>
            <p class="upload-tit"><i class="el-icon-camera-solid"></i>上传照片</p>
            <div class="upload-list">
                <upload-file v-model="photo" :limit="9" />
            </div>
            <button type="button" class="btn-release" @click="addDynamic()">确认发布</button>
        </div>
        <!--<span slot="footer" class="dialog-footer">
                <el-button @click="cancelDialog()">取 消</el-button>
                <el-button type="primary" @click="loginDialogVisible = false">确 定</el-button>
            </span>-->
    </el-dialog>
</template>
<script>
    import uploadFile from '../uploadFile/index'
    import {addDynamic} from '../../api/dynamic'
    export default {
        props:{
            releaseDialogVisible:{
                type:Boolean,
                default:false
            }
        },
        computed:{

        },
        components:{
            uploadFile
        },
        data(){
            return {
                userInfo:JSON.parse(localStorage.getItem('user'))||null,
                title:'',
                content:'',
                photo:''
            }
        },
        methods:{
            cancelDialog(){
                this.$emit('cancelDialog');
            },
            handleDialogClose(){
                this.$emit('cancelDialog');
            },
            addDynamic(){
                if(this.content===''){
                    this.$message({
                        message:'请输入发布内容',
                        type:'warn'
                    });return;
                }
                addDynamic({
                    userId:this.userInfo.userId,
                    title:this.content,
                    content:this.content,
                    photo:this.photo,
                    dynamicId:0
                }).then(()=>{
                    this.$message({
                        message:'发布成功',
                        type:'success'
                    });
                    //window.location.reload();
                })
            }
        }

    }
</script>
<style lang="scss" scoped>
    @import "../../assets/css/common";
    .release-dialog{
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        border-radius: 20px;
    }

    .dialog-cont{
        padding:0 10px;
        .title{
            font-size:24px;
            color:#333333;
            font-weight:600;
            text-align: center;
            padding-top:10px;
        }
        .tips{
            color:#888888;
            font-size:16px;
            text-align: center;
            padding:19px 0 38px;
        }
        .upload-tit{
            color:#013412;
            font-size:16px;
            padding:30px 0 20px;
        }
        .btn-release{
            width:220px;
            height:36px;
            color:#ffffff;
            background-color:$main-color;
            font-size:16px;
            -webkit-border-radius: 4px;
            -moz-border-radius: 4px;
            border-radius: 4px;
            margin:48px 0 26px 190px;
        }
    }

</style>
<style lang="scss">
    .release-dialog .el-dialog__header{
        padding:0;
    }
    .release-dialog .el-dialog__headerbtn{
        top:-10px;
        right:-48px;
        color:#ffffff;
        font-size:24px;
    }
    .release-dialog .el-dialog__body{background: #F7F7F7;}
    .release-dialog .el-dialog__headerbtn .el-dialog__close{
        color:#ffffff;
    }
    .release-dialog .el-upload-list--picture-card .el-upload-list__item,.release-dialog .el-upload--picture-card{
        width:79px;
        height:79px;
        line-height:77px;
    }
</style>